/**
 * Date Constants
 * this file contains date different formatting constants
 *
 * Naming Convention: SCREAMING_SNAKE_CASE
 * i.e. BIRTH_DATE_FORMAT
 */

export const MONTHS_EN = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MONTHS_AR = [
  'يناير',
  'فبراير',
  'مارس',
  'إبريل',
  'مايو',
  'يونيه',
  'يوليو',
  'أغسطس',
  'سبتمير',
  'أكتوبر',
  'نوفمبر',
  'ديسمبر',
];

export const DATE_PICKER = {
  START_DATE: 'startDate',
  END_DATE: 'endDate',
};

export const DATE_FORMATS = {
  RECENT_SEARCH_RESULTS: 'iii, d MMM',
  DATE_PICKER_EN: 'iii, d MMM',
  DATE_PICKER_AR: 'eeee, d MMM',
  JOURNEY_DATE_FORMAT: 'MMM dd',
  DATE_INPUT_DATE_FORMAT: 'dd / MM / yyyy',
  DATE_OF_BIRTH_DISPLAY: 'dd/MM/yyyy',
  FLIGHT_DETAILS_DATE_FORMAT: 'EEE, dd MMM yyyy',
  REFRESH_DIALOG: 'dd MMM',
  SEARCH_HEADER: 'dd MMM',
  FARE_CALENDAR_DATE_SHORT_FORMAT: 'dd LLL',
  FARE_CALENDAR_DATE_LONG_FORMAT: 'eeee, dd LLL',
  FARE_CALENDAR_HEADER: 'd MMM',
  DAY_FORMAT_AR: 'eeee',
  DAY_FORMAT_EN: 'E',
};

/**
 * Temporary const to map date-fns v1 date formats to v2 format
 */
export const DATE_FORMAT_MAP = {
  'YYYY-MM-DD': 'yyyy-MM-dd',
};

export const DATE_WITH_TIME_PARSE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
export const DATE_WITH_TIME_FORMAT = 'yyyy-MM-dd HH:mm';
export const TIME_FORMAT_24 = 'HH:mm';

export const INVALID_DATE_FORMAT = 'Invalid Date';

export const TRAVELLER_AGE_YEAR_MAP = {
  // Adult should be minimum 12 years old
  ADT: {
    years: 110,
    startYearOffset: 12,
  },
  // child should be minumum 2 years old and maximum 10+2 years old
  CH: {
    years: 10,
    startYearOffset: 2,
  },
  // Infant should not be above 0+2 years old
  INF: {
    years: 2,
    startYearOffset: 0,
  },
};

export const DATE_TYPES = {
  ADT: 'ADT',
  CH: 'CH',
  INF: 'INF',
  ID_EXPIRY: 'idExpiryDate',
};

export const DATE_INPUT_FIELDS = {
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year',
} as const;
